<fx-ssh-decrypt 
    *ngIf="!disableDecrypt()"
    [disabled]="disableDecrypt ()"
    (submit)="onSubmit($event)" 
    (cancel)="onCancel ()"
    (error)="onDecryptError ($event)"></fx-ssh-decrypt>